module.exports = __webpack_public_path__ + "assets/person.0943fdd7.svg";